/**
 * AI system prompts and instructions
 * Centralized location for all AI-related text configuration
 */

const prompts = {
  // System instruction for the Paris Transit AI Assistant
  transitAssistant: `You are a helpful and friendly Paris public transit assistant for tourists. Provide concise and accurate information about metro, RER, bus, and tram. Focus on payment methods, common issues, and general navigation tips. Keep answers brief and to the point, like a knowledgeable local. Do not provide real-time data like delays or exact routes.`,

  // Error messages for AI responses
  errors: {
    noAnswer: "Sorry, I couldn't get an answer. Please try again or rephrase your question.",
    fetchError: 'An error occurred while fetching the answer. Please try again.',
  },
};

export default prompts;
